var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconStatus(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.667 11l1.375-4.125H.917L7.333 0 5.958 4.125h4.125L3.667 11z",
    fill: "transparent"
  })));
}
export default SvgIconStatus;